<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="12" class="gutter-row">
            <h2>Servers</h2>
          </a-col>
          <a-col :span="12" class="gutter-row" :style="{ textAlign: 'end' }">
            <a-button type="primary" icon="plus-circle" @click.prevent="visibleModal = true">Add Server</a-button>
            <a-modal
              title="Add new server"
              v-model="visibleModal"
              @ok="handleOk"
            >
              <a-form-item
                label="API KEY"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 17 }"
              >
                <a-input v-model="apiKey" />
                <span class="ant-form-explain" v-if="message.api_key" style="color: darkred;">{{ message.api_key[0] }}</span>
              </a-form-item>
              <a-form-item
                label="Server ID"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 17 }"
              >
                <a-input v-model="serverId" />
                <span class="ant-form-explain" v-if="message.server_id" style="color: darkred;">{{ message.server_id[0] }}</span>
              </a-form-item>
              <template slot="footer">
                <a-button key="submit" type="primary" @click.prevent="handleOk" :loading="submitting">
                  Save Server
                </a-button>
              </template>
            </a-modal>
          </a-col>
        </a-row>
        <template v-if="loading">
          <div class="loader-container">
            <a-spin :size="'large'" />
          </div>
        </template>
        <template v-else>
          <a-row :gutter="40">
            <template v-if="servers.length">
              <single-server-card v-for="server in servers"
                    :key="server.id"
                    :info="server"
                    @remove="removeServer"
              ></single-server-card>
            </template>
            <template v-else>
              <h3 style="margin-top: 20px; margin-left: 20px; font-size: 1.2em;">No server was found to display.</h3>
            </template>
          </a-row>
        </template>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { mapGetters } from "vuex";
import Sidebar from "@/components/Sidebar.vue";
import SingleServerCard from "@/components/SingleServerCard.vue";
export default {
  components: {
    Sidebar,
    SingleServerCard
  },
  data() {
    return {
      loading: true,
      submitting: false,
      visibleModal: false,
      apiKey: '',
      serverId: '',
      message: {},
      interval: null
    }
  },
  computed: {
    ...mapGetters({
      servers: "servers/getLists",
    })
  },
  methods: {
    async getServerInfo(loading = true) {
      if (loading) {
        this.loading = true;
      }
      await this.$store.dispatch('servers/GET_API_KEYS_FROM_CACHE');
      this.loading = false;
      this.interval = setTimeout(() => {
            this.getServerInfo(false);
        }, 120000);
    },
    async handleOk() {
      this.submitting = true;
      this.message = {};
      try {
        await this.$store.dispatch("servers/ADD_NEW_API_KEY_INTO_CACHE", {api_key: this.apiKey, server_id: this.serverId});
        this.visibleModal =  false;
        this.apiKey = '';
        this.submitting = false;
        this.getServerInfo();
        this.$weNotify("success", `Server #${this.serverId} Added.`);
        this.serverId = '';
      }catch(err) {
        this.message = err.response.data.errors;
        this.submitting = false;
      }
    },
    async removeServer(data) {
      this.loading = true;
      await this.$store.dispatch("servers/REMOVE_SERVER_FROM_CACHE", data);
      this.loading = false;
      this.$weNotify("success", `Server #${data.id} Removed.`);
    }
  },
  created() {
    this.getServerInfo();
  },
  destroyed() {
      clearTimeout(this.interval);
  }
};
</script>
